<!-- @format -->

<!-- eslint-disable @angular-eslint/template/no-inline-styles -->

<div class="hmf-display-flex hmf-align-items-center hmf-justify-flex-start hmf-mb-s hmf-mt-s">
	<pdp-back-to-search-results></pdp-back-to-search-results>
	@if (
		browseBreadcrumbsEnabled() &&
		(primaryCategoryBreadcrumb || chain.chainIdentifierAbbr !== 'dsg')
	) {
		<div class="hmf-ml-s">
			<pdp-breadcrumb [categoryId]="primaryCategoryBreadcrumb"> </pdp-breadcrumb>
		</div>
	}
</div>

@if (isRibbonGAMBannerEnabled()) {
	<shared-components-google-ad-manager
		[data]="'top_ribbon_banner'"
		[showSponsoredLabel]="true"
		[enableTooltipSurvey]="true"
		[hasTopMargin]="false"
		[enableAdCarousel]="true"
		[isNarrowBanner]="false">
	</shared-components-google-ad-manager>

}

<div
	id="pdp-upper-left"
	class="hmf-grid">
	<div
		data-testid="oos-product-name"
		class="hmf-col hmf-flex-sm-row hmf-span-xxsm-12 hmf-span-lg-7 hmf-mb-xs hmf-mb-m-0 hmf-pr-lg-0">
		<div class="hmf-flex-xxsm-col hmf-justify-content-center hmf-align-items-center">
			<p
				class="hmf-display-sm-none hmf-mb-xs hmf-header-bold-s hmf-header-bold-lg-m"
				itemprop="name">
				{{ product?.name }}
			</p>
			@if (!reviewsOff()) {
				<div
					class="hmf-display-flex hmf-display-sm-none"
					[ngClass]="{
						'hmf-mb-xxs': isHighlyRatedReviewsEnabled(),
						'hmf-mb-xs': !isHighlyRatedReviewsEnabled()
					}">
					<product-reviews-rating-summary-stars
						[class.hmf-mr-xxs]="useProductCatalogRatingData()"
						[productPartNumber]="product?.partNumber"
						[isDrawerAvailable]="newReviews()"
						[ratingCount]="ratingCount()"
						[ratingValue]="ratingValue()"
						[useProductCatalogRatingData]="useProductCatalogRatingData()"
					></product-reviews-rating-summary-stars>
					@if (isReviewImgPlacementEnabled()) {
						<product-reviews-multimedia-count></product-reviews-multimedia-count>
					}
				</div>

				@if (isHighlyRatedReviewsEnabled()) {
					<div class="hmf-display-sm-none hmf-mb-xs">
						<product-reviews-review-highly-rated-features
							template="out-of-stock"
							(open)="openHighlyRatedFeatures()" />
					</div>
				}
			}

			<div class="hmf-display-none hmf-display-sm-flex">
				<img
					class="desktop-product-image"
					[attr.loading]="isMobile ? 'lazy' : 'eager'"
					[src]="oosImageUrl"
					alt="sorry, {{ product?.name }} is currently out of stock"
					(error)="imageError()"
					width="382"
					height="382"
					(load)="imageLoad()" />
			</div>
			<div class="hmf-display-xxsm hmf-display-sm-none">
				<div class="hmf-display-md-none">
					@if (!useAboveTheFoldMobileContainer()) {
						<pdp-product-image-carousel
							[location]="templateName"
							[product]="product"
							[chainIdentifierAbbr]="chain?.chainIdentifierAbbr"
							[swatchColor]="selectedColorAttribute">
						</pdp-product-image-carousel>
					} @else {
						<!-- Mobile Carousel View -->
						<ng-container #targetAboveTheFoldViewRef></ng-container>
						<div
							[ngClass]="{
								'carousel-initial-container': !wasAboveTheFoldContentLoaded,
								'carousel-badge': product?.badge
							}"></div>
					}
				</div>
			</div>
		</div>
		<div
			class="hmf-col hmf-flex-col hmf-span-xxsm-12 hmf-span-sm-7 hmf-justify-content-center hmf-px-l">
			<p
				class="hmf-display-none hmf-display-sm-flex hmf-mb-xs hmf-header-bold-s hmf-header-bold-lg-m"
				itemprop="name">
				{{ product?.name }}
			</p>
			@if (!reviewsOff()) {
				<div class="hmf-display-none hmf-display-sm-flex">
					<product-reviews-rating-summary-stars
						[class.hmf-mr-xxs]="useProductCatalogRatingData()"
						[productPartNumber]="product?.partNumber"
						[isDrawerAvailable]="newReviews()"
						[ratingCount]="ratingCount()"
						[ratingValue]="ratingValue()"
						[useProductCatalogRatingData]="useProductCatalogRatingData()"
					></product-reviews-rating-summary-stars>
					@if (isReviewImgPlacementEnabled()) {
						<product-reviews-multimedia-count></product-reviews-multimedia-count>
					}
				</div>

				@if (isHighlyRatedReviewsEnabled()) {
					<div class="hmf-display-none hmf-display-sm-flex hmf-mt-xxs">
						<product-reviews-review-highly-rated-features
							template="out-of-stock"
							(open)="openHighlyRatedFeatures()" />
					</div>
				}
			}

			<div class="hmf-display-flex hmf-justify-content-center hmf-justify-content-sm-start">
				<p class="hmf-body-l hmf-my-m label-negative">Sorry, this item is out of stock</p>
			</div>
		</div>
	</div>
	<div
		class="hmf-col hmf-span-xxsm-12 hmf-span-lg-5 hmf-pl-l-0"
		[ngClass]="chain?.chainIdentifierAbbr === 'pl' ? ' pl-info-container' : ''">
		<!-- Certona Recommendations 'Similar Products' -->
		<div
			id="oosproduct_rr"
			class="product-cross-sells-1">
			<shared-components-product-recommendations
				data-testid="similar-products"
				[isOOSSimilarProducts]="true"
				[displayName]="'Similar Products'"
				[schemes]="'schemes'"
				[filterBy]="'oosproduct_rr'"
				[showViewMoreLink]="true"
				[homefieldCarouselEnabled]="true"
				[showSkeletonLoading]="isLoadingStateRecsEnabled()">
			</shared-components-product-recommendations>
		</div>
		@if (oosBreadCrumbData?.name.length) {
			<div
				class="hmf-display-flex hmf-align-items-center hmf-justify-content-center hmf-mx-m-xs">
				<a
					hmf-button
					variant="secondary"
					[href]="oosBreadCrumbData?.url"
					ariaLabel="{{ oosCtaText }}"
					classList="shop-all-button hmf-py-s"
					[text]="oosCtaText"></a>
			</div>
		}
	</div>
	<!-- end right side PDP selection area div -->

	<!-- Certona Recommendations 'Customers Also Bought' -->
	<div class="hmf-col hmf-span-12 hmf-mt-xxl hmf-mt-xl hmf-mt-lg-xxl">
		<div
			id="oosproduct2_rr"
			class="product-cross-sells-1">
			<shared-components-product-recommendations
				data-testid="customers-also-bought-new-oss"
				[displayName]="'Customers Also Bought'"
				[schemes]="'schemes'"
				[filterBy]="'oosproduct2_rr'"
				[showViewMoreLink]="true"
				[showQVButtons]="false"
				[homefieldCarouselEnabled]="true"
				[showSkeletonLoading]="isLoadingStateRecsEnabled()">
			</shared-components-product-recommendations>
		</div>
	</div>
	<!-- Certona Recommendations 'Recently Viewed' -->
	<div class="hmf-col hmf-span-12">
		<div
			id="oosproduct1_rr"
			class="product-cross-sells-1">
			<shared-components-product-recommendations
				data-testid="recently-viewed-new-oss"
				[displayName]="'Recently Viewed'"
				[schemes]="'schemes'"
				[filterBy]="'oosproduct3_rr'"
				[showViewMoreLink]="false"
				[showQVButtons]="false"
				[homefieldCarouselEnabled]="true"
				[showSkeletonLoading]="isLoadingStateRecsEnabled()">
			</shared-components-product-recommendations>
		</div>
	</div>
</div>
<!-- end homefield grid -->

<div
	id="pdp-upper-right"
	class="flex-item-right">
	<pdp-product-info-specs
		class="hmf-mb-m"
		[product]="product">
		<ng-container *ngTemplateOutlet="productInfoSpecs"></ng-container>
	</pdp-product-info-specs>
	@if (!reviewsOff() && (!useProductCatalogRatingData() || ratingCount())) {
		<div class="hmf-col hmf-display-flex hmf-flex-column hmf-span-12 hmf-mt-l hmf-mb-xl">
			<ng-container *ngTemplateOutlet="productReviews"></ng-container>
		</div>
	}
	<ng-template #productInfoSpecs>
		<div class="pdp-component-area">
			<pdp-product-description
				[product]="product"
				[resolvedSkuID]="resolvedSku?.partNumber"
				[isOOSProductDescription]="true"
				[infoSummaryEnabled]="infoSummaryEnabled()">
			</pdp-product-description>
			@if (product?.techSpecs) {
				<pdp-tech-specs
					[techSpecs]="product?.techSpecs"
					[isOOSProductSpecs]="true">
				</pdp-tech-specs>
			}
		</div>
	</ng-template>
	<ng-template #productReviews>
		<div class="pdp-component-area">
			@if (!newReviews() && !reviewsMVPRetest()) {
				<product-reviews-bv-reviews
					class="hmf-mt-xl hmf-display-block"
					[productIdentifier]="product?.partNumber">
				</product-reviews-bv-reviews>
			}
			<!-- Reviews Highlight -->
			@if (reviewsMVPRetest()) {
				<product-reviews-highlight-container
					[productIdentifier]="product?.partNumber"
					[ratingValue]="useProductCatalogRatingData() ? ratingValue() : null"
					[ratingCount]="useProductCatalogRatingData() ? ratingCount() : null"
				></product-reviews-highlight-container>
			}
		</div>
	</ng-template>
</div>

<!-- BV Questions and Answers Column -->
@if (!reviewsOff() && !newReviews()) {
	<product-reviews-questions-and-answers-v2
		class="pdp-component-area"
		[productIdentifier]="product?.id">
	</product-reviews-questions-and-answers-v2>
}

<!-- Display highly rated for modal to have z-index priority over other elements -->
@if (!reviewsOff() && isHighlyRatedReviewsEnabled()) {
	<product-reviews-review-highly-rated-features-modal #highlyRatedFeaturesModal>
	</product-reviews-review-highly-rated-features-modal>
}
